import { Section } from '../../components/Section'
import { AnimatedPhrases } from '../../components/AnimatedPhrases'
import { MainBanner } from '../../components/MainBanner'
import { AnimatedPortfolio } from '../../components/AnimatedPortfolio'

export function Home() {
 return (
  <>
   <Section
    id="home"
    title="Home"
    className="home top-0 relative max-[991px]:h-full h-[970px]"
   >
    <div className="container">
     <div className="flex h-screen max-[991px]:h-auto items-center justify-between gap-4">
      <AnimatedPhrases />
      <div className="block max-[991px]:hidden w-1/2 z-10 relative">
       <p className="pl-40 text-[var(--text-main)] font-normal text-[17px] font-['rns-milesregular']">
        Somos parte da geração <br /> que nega rótulos e definições. <br />
        Somos flexíveis e altamente adaptáveis <br />
        às mais diversas demandas. <br />
        Valorizamos a cultura da soma. <br />
        Acreditamos que o “E” é sempre <br />
        melhor que o “OU”. <br />
        Apostamos na potência dos diálogos. <br />
        Na conexão com o outro. <br />E em ideias livres de amarras <br />
        ou regras pré-concebidas.
       </p>
      </div>
     </div>
    </div>
   </Section>
   <Section id="destaque" title="Destaque">
    <MainBanner />
   </Section>
   <Section id="portfolio" title="Portfolio" className="py-16 max-[768px]:py-0">
    <div className="container no-padding">
     <AnimatedPortfolio />
    </div>
   </Section>
   <Section
    id="onoff"
    title="On/Off"
    className="bgYellow h-80 max-[768px]:h-52"
   >
    <div className="container h-full">
     <div className="h-full flex items-center justify-center">
      <h1 className="font-['rns-milesblack'] font-bold text-black text-3xl">
       On. Off. Humana.
      </h1>
     </div>
    </div>
   </Section>
  </>
 )
}
